import { PropsWithClassName } from '@boltenergy-be/design-system'
import classNames from 'classnames'

const Logo = ({ className }: PropsWithClassName) => {
  return (
    <svg
      width="1229"
      height="474"
      viewBox="0 0 1229 474"
      className={classNames(className)}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-describedby="logo-title"
      role="img"
    >
      <title id="logo-title">Bolt Logo</title>
      <path
        d="M684.403 112.419C573.044 112.419 494.586 187.007 494.586 293.649C494.586 400.291 573.044 473.03 684.403 473.03C795.762 473.03 874.219 399.058 874.219 293.649C874.219 188.24 795.762 112.419 684.403 112.419ZM684.403 383.031C629.356 383.031 590.76 346.046 590.76 293.649C590.76 241.253 629.356 203.034 684.403 203.034C739.45 203.034 777.413 240.636 777.413 293.649C777.413 346.662 738.817 383.031 684.403 383.031Z"
        fill="currentColor"
      />
      <path d="M889.323 467.529H989.913L990.039 20.6185H889.323V467.529Z" fill="currentColor" />
      <path
        d="M1197.36 359.854C1156.24 389.442 1107.52 386.976 1107.52 340.744V238.787H1190.91V156.802H1107.52V64.9545H1006.91L1007.55 315.841C1006.91 315.841 1007.55 351.593 1007.55 351.593C1007.55 431.113 1053.44 473.03 1122.07 473.03C1122.07 473.03 1188.51 474.263 1229 436.044L1197.36 359.854Z"
        fill="currentColor"
      />
      <path
        d="M434.452 201.461C404.366 172.15 364.48 155.87 321.986 155.531C321.98 155.531 321.973 155.531 321.961 155.531C321.961 155.525 321.961 155.519 321.961 155.512C321.606 114.119 304.896 75.2474 274.817 45.9424C244.414 16.3168 203.99 0 160.984 0C117.977 0 77.5591 16.3168 47.1505 45.9362C16.7482 75.5617 0 114.945 0 156.838V469.2H320.619C363.619 469.2 404.05 452.883 434.452 423.264C464.861 393.639 481.603 354.255 481.603 312.363C481.603 270.47 464.855 231.08 434.452 201.461ZM320.619 374.85H96.8508V156.838C96.8508 122.386 125.621 94.3566 160.984 94.3566C196.346 94.3566 225.338 118.964 225.338 162.897C199.023 168.445 176.719 176.792 158.946 187.764C127.652 207.089 110.119 235.235 109.391 267.215C109.012 273.022 109.1 281.282 111.043 290.837C114.396 307.289 122.267 322.361 133.821 334.418C160.408 362.188 194.176 363.36 207.16 362.626C240.048 361.966 269.002 344.879 288.869 314.341C300.132 297.026 308.705 275.426 314.393 249.783C360.879 249.783 384.752 277.904 384.752 312.356C384.752 346.809 355.982 374.837 320.619 374.837V374.85ZM226.711 246.91C223.813 256.742 219.877 263.899 216.916 268.498C213.31 274.095 210.665 276.622 207.052 277.719C206.267 277.954 200.858 279.593 197.188 276.53L196.315 275.679C193.17 272.11 194.853 266.833 195.094 266.069C196.22 262.549 198.814 259.972 204.559 256.459C209.279 253.568 216.625 249.74 226.717 246.916L226.711 246.91Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Logo
